import { Text } from 'theme-ui';
import * as React from 'react';
export default {
  Text,
  React
};